import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminTabsEnum } from './admin-tabs.enum';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const AdminNavigation = withRouter(
  connect()(({ location }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(location.pathname);

    const changeTab = (event) => {
      setActiveTab(event.target.getAttribute('tab'));
    };

    return (
      <div className="as9d0flksad09-admin-navigation">
        <div className="container">
          <div className="row">
            <h1 className="col admin-navigation-title">CorporateTube {t('administration')}</h1>
          </div>
          <nav id="page-navigation" tabIndex={-1} className="row">
            <Link
              className={'ct-drop-down-nav' + (AdminTabsEnum.RIGHTS === activeTab ? ' active' : '')}
              tab="administration"
              to="/administration"
              onClick={changeTab}
            >
              {t('rights')}
            </Link>
            <Link
              className={'ct-drop-down-nav' + (AdminTabsEnum.CHANNEL_ACCESS === activeTab ? ' active' : '')}
              tab="channel-access"
              to="/channel-access"
              onClick={changeTab}
            >
              {t('channel_access')}
            </Link>
            <Link
              className={'ct-drop-down-nav' + (AdminTabsEnum.START_CHANNEL === activeTab ? ' active' : '')}
              tab="start-channel"
              to="/start-channel"
              onClick={changeTab}
            >
              {t('start_channel')}
            </Link>
          </nav>
        </div>
      </div>
    );
  })
);
